import {
  CreditCardStatusCode,
  PaymentCardProductType,
} from '__generated__/GQL';

import { PaymentCardListTable_ItemFragment } from '../../../../hooks/usePaymentCardsList/paymentCardsList.gql';
import locales from './locales';

export const getCardKey = (
  card: PaymentCardListTable_ItemFragment,
): PaymentCardProductType => {
  return card.cardProductType;
};

export const getCardName = (card: PaymentCardListTable_ItemFragment) => {
  if (card.alias) {
    return card.alias;
  }

  return locales.cardProductType[getCardKey(card)];
};

export const isCreatedCard = (card: PaymentCardListTable_ItemFragment) => {
  return [CreditCardStatusCode.Created].includes(card.status);
};

export const isPendingCard = (card: PaymentCardListTable_ItemFragment) => {
  return [
    CreditCardStatusCode.Inactive,
    CreditCardStatusCode.Stolen,
    CreditCardStatusCode.Deactivated,
    CreditCardStatusCode.Lost,
    CreditCardStatusCode.Locked,
  ].includes(card.status);
};
